// src/jsMain/kotlin/AppConfig.kt

@JsModule("process")
external val process: dynamic

external val API_URL: String

object AppConfig {
    val apiUrl: String
        get() = API_URL

//    val environment: String
//        get() = process.env.NODE_ENV as String
//
//    val isDevelopment: Boolean
//        get() = environment == "development"
//
//    val isProduction: Boolean
//        get() = environment == "production"

//    // 根據環境返回不同配置
//    val logLevel: String
//        get() = when {
//            isDevelopment -> "debug"
//            isProduction -> "error"
//            else -> "info"
//        }

    // API 端點
    val apiEndpoints = object {
        val users = "$apiUrl/api/users"
        val products = "$apiUrl/api/products"
        val orders = "$apiUrl/api/orders"
    }
}